// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"
// 
// // // Localhost 
// export const CORE_API_ENDPOINT = "http://localhost:2600"
// export const REDIRECT_O365_URI = "http://localhost:8080/login"
// export const AX_URL = "http://localhost:8080"

// WMS UAT Server
// export const CORE_API_ENDPOINT = "https://wmstest.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://wmstest.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// WMS Prod Server
export const CORE_API_ENDPOINT = "https://wms.cigblusolutions.com/api"
export const REDIRECT_O365_URI = "https://wms.cigblusolutions.com/login"
export const AX_URL = "https://cib.operations.dynamics.com"

// External Connect Server
// Test
export const QR_READER_ENDPOINT = "https://imsv2test.cigblusolutions.com"
// Prod
// export const QR_READER_ENDPOINT = "https://imsv2.cigblusolutions.com" 

export const CLIENT_ID = "0b1bf20d-a148-44d2-8932-027dbaf66a46"
export const ACTIVE_ITEM_TAB = 6   //6
export const ACTIVE_ITEM2_TAB = 2   //6
export const VERSION_NO = "1.1.0"
export const SYSTEM_NAME = `${(CORE_API_ENDPOINT.search("localhost") > -1) || (CORE_API_ENDPOINT.search("test") > -1) ? "WMSUAT" : "WMSPROD"}`



// WEBPACK FOOTER //
// ./src/lib/api.js